import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';

const config = {
    apiKey: "AIzaSyD2TRiyOXhPZZqdg_eHYqL7_YsSzmfqz80",
    authDomain: "chat-app-7c191.firebaseapp.com",
    databaseURL: "https://chat-app-7c191-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "chat-app-7c191",
    storageBucket: "chat-app-7c191.appspot.com",
    messagingSenderId: "268566535601",
    appId: "1:268566535601:web:c2baf1876d3894bc10f190"
};

const app = firebase.initializeApp(config);
export const auth = app.auth();
export const database = app.database();
export const storage = app.storage();